"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasTemporaryRect = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
exports.CanvasTemporaryRect = (0, react_1.memo)(function (_a) {
    var canvasSize = _a.canvasSize, temporaryRectCurr = _a.temporaryRect, borderWidthPx = _a.borderWidthPx, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    var temporaryRectPrev = (0, utils_1.usePrevious)(temporaryRectCurr);
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        if (temporaryRectPrev === undefined)
            return;
        window.requestAnimationFrame(function () {
            context.clearRect(temporaryRectPrev.left - borderWidthPx, temporaryRectPrev.top - borderWidthPx, temporaryRectPrev.width + 2 * borderWidthPx, temporaryRectPrev.height + 2 * borderWidthPx);
            var top = temporaryRectCurr.top, left = temporaryRectCurr.left, width = temporaryRectCurr.width, height = temporaryRectCurr.height;
            // draw inner box face
            context.fillStyle = backgroundColor;
            context.fillRect(left, top, width, height);
            // draw border lines
            context.strokeStyle = borderColor;
            context.lineWidth = borderWidthPx;
            context.strokeRect(left, top, width, height);
        });
    }, [
        context,
        temporaryRectPrev,
        temporaryRectCurr,
        backgroundColor,
        borderColor,
        borderWidthPx
    ]);
    return (react_1.default.createElement("canvas", { ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasTemporaryRect.displayName = 'CanvasTemporaryRect';
